import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { type Profile } from "@/types/profile";
import { Switch } from "@/components/ui/switch";
import { InfoIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface BasicInformationProps {
  profile: Profile;
  onProfileChange: (updatedProfile: Profile) => void;
}

export const BasicInformation = ({ profile, onProfileChange }: BasicInformationProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="username">Username</Label>
        <Input
          id="username"
          value={profile.username || ''}
          onChange={(e) => onProfileChange({ ...profile, username: e.target.value })}
          required
        />
      </div>

      <div>
        <Label htmlFor="bio">Bio</Label>
        <Textarea
          id="bio"
          value={profile.bio || ''}
          onChange={(e) => onProfileChange({ ...profile, bio: e.target.value })}
          rows={4}
        />
      </div>

      <div>
        <Label htmlFor="contactInfo">Contact Information</Label>
        <Input
          id="contactInfo"
          value={profile.contactInfo || ''}
          onChange={(e) => onProfileChange({ ...profile, contactInfo: e.target.value })}
        />
      </div>

      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center space-x-2">
          <Label htmlFor="showContactInfo">Show contact information publicly</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <InfoIcon className="h-4 w-4 text-gray-500" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="w-60">When enabled, your contact information will be visible to all users. Disable to keep it private.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id="showContactInfo"
          checked={profile.showContactInfo ?? true}
          onCheckedChange={(checked) => onProfileChange({ ...profile, showContactInfo: checked })}
        />
      </div>
    </div>
  );
};
